import { Outlet } from "react-router-dom";
import { SignUpContextProvider } from "@/components/organisms";
import { ForgotPassword, Login, ResetPassword, SignUpInvite, SignUp } from "@/components/pages";
import { DriverSignUp } from "@/components/pages/SignUp/DriverSignUp";
import { OperatorSignUp } from "@/components/pages/SignUp/OperatorSignUp";

export const authRoutes = [
  {
    path: "login",
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: ":providerCode",
        element: <Login />,
      },
    ],
  },
  {
    path: "signup",
    element: (
      <SignUpContextProvider>
        <Outlet />
      </SignUpContextProvider>
    ),
    children: [
      {
        index: true,
        element: <SignUp />,
      },
      {
        path: ":providerCode",
        element: <SignUp />,
      },
      {
        path: "driver",
        element: <DriverSignUp />,
      },
      {
        path: "driver/:providerCode",
        element: <DriverSignUp />,
      },
      {
        path: "operator",
        element: <OperatorSignUp />,
      },
    ],
  },
  {
    path: "invite/:token",
    element: (
      <SignUpContextProvider>
        <SignUpInvite />
      </SignUpContextProvider>
    ),
  },
  {
    path: "forgot-password",
    children: [
      {
        index: true,
        element: <ForgotPassword />,
      },
      {
        path: "reset/:token",
        element: <ResetPassword />,
      },
    ],
  },
];
